var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYieldFarming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2001 3.20013C15.7757 3.20013 15.3688 3.03156 15.0687 2.7315C14.7686 2.43144 14.6001 2.02448 14.6001 1.60013C14.6001 1.17578 14.7686 0.768818 15.0687 0.46876C15.3688 0.168702 15.7757 0.000130652 16.2001 0.000130652H24.2001C24.6244 0.000130652 25.0314 0.168702 25.3314 0.46876C25.6315 0.768818 25.8001 1.17578 25.8001 1.60013V9.60013C25.8001 10.0245 25.6315 10.4314 25.3314 10.7315C25.0314 11.0316 24.6244 11.2001 24.2001 11.2001C23.7757 11.2001 23.3688 11.0316 23.0687 10.7315C22.7686 10.4314 22.6001 10.0245 22.6001 9.60013V5.46253L15.7313 12.3313C15.4312 12.6313 15.0243 12.7998 14.6001 12.7998C14.1758 12.7998 13.7689 12.6313 13.4689 12.3313L9.80007 8.66253L2.93127 15.5313C2.6295 15.8228 2.22534 15.9841 1.80582 15.9804C1.38631 15.9768 0.985009 15.8085 0.688356 15.5118C0.391703 15.2152 0.223433 14.8139 0.219787 14.3944C0.216142 13.9749 0.377412 13.5707 0.668865 13.2689L8.66887 5.26893C8.96891 4.96898 9.3758 4.80047 9.80007 4.80047C10.2243 4.80047 10.6312 4.96898 10.9313 5.26893L14.6001 8.93773L20.3377 3.20013H16.2001Z",
    fill: "#06D6A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYieldFarming);
export default __webpack_public_path__ + "static/media/yield-farming.767c9add473c2b164674b923f6d4489b.svg";
export { ForwardRef as ReactComponent };